import { put, post, get, del } from "@utils/axios";

const api = "user-management/users";

export const getFilters = () => {
  return get(`${api}/filters`);
}

export const getUsersReq = (payload) => {
  return get(`${api}`, payload);
}

export const createUserReq = (payload) => {
  return post(`${api}`, payload);
}

export const deleteUserReq = (id) => {
  return del(`${api}/${id}`);
}

export const updateUserReq = (payload) => {
  return put(`${api}/${payload.object.id}`, payload);
}

export const changeStatusReq = (payload) => {
  return post(`${api}-status`, payload);
}

export const getClinicsReq = () => {
  return get(`common/get-clinics`);
}